module.exports = __webpack_public_path__ + "img/main_partner_inquiry_hover.fe3b184e.png";